<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { gsap } from 'gsap';
import { guideCategories } from '../config/categories.js';

const root = ref(null);
let context;

function runEntrance() {
  if (!root.value || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  context = gsap.context(() => {
    gsap.timeline({ scrollTrigger:{ trigger:root.value,start:'top 77%',once:true },defaults:{ ease:'power3.out' } })
      .from('.category-explorer-title>span',{ yPercent:105,autoAlpha:0,duration:.82,ease:'power4.out' })
      .from('.category-explorer-header p,.category-explorer-header i',{ y:12,autoAlpha:0,duration:.42,stagger:.07 },'-=.4')
      .from('.home-category-equal-card',{ y:18,clipPath:'inset(0 0 13% 0 round 20px)',autoAlpha:0,stagger:{ each:.055,grid:[2,6],from:'start' },duration:.52 },'-=.18');
  },root.value);
}

onMounted(runEntrance);
onBeforeUnmount(() => context?.revert());
</script>

<template>
  <section id="categories" ref="root" class="section home-category-explorer home-category-equal-section" aria-labelledby="category-explorer-heading">
    <div class="category-explorer-wrap">
      <header class="category-explorer-header">
        <h2 id="category-explorer-heading" class="category-explorer-title"><span>استكشف أقسام الدليل</span></h2>
        <p>اختر من أقسام الدليل ما يناسب احتياجك</p>
        <i aria-hidden="true"></i>
      </header>

      <div class="home-category-equal-grid">
        <RouterLink v-for="category in guideCategories" :key="category.id" class="home-category-equal-card" :to="category.route" :aria-label="`استكشف قسم ${category.title}`">
          <div class="home-category-equal-top"><em>{{ category.number }}</em><span><i class="bi" :class="category.icon"></i></span></div>
          <h3>{{ category.title }}</h3>
          <p>{{ category.shortDescription }}</p>
          <i class="home-category-equal-arrow bi bi-arrow-left" aria-hidden="true"></i>
        </RouterLink>
      </div>
    </div>
  </section>
</template>
